import * as React from "react";
import classnames from "classnames";
import { observer, inject } from "mobx-react";
import { Link } from "react-router-dom";
//import MyPages from "../MyPages/MyPages";
import ReactResizeDetector from 'react-resize-detector';
import { matchPath } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MarketSelector from '@components/Navigation/market-selector'

@inject("store")
@observer
export default class MobileNavigation extends React.Component {
    currentHeight = 0;
    constructor(props) {
        super(props);
        this.navigationStore = this.props.store.navigation;
        //this.addEvents = this.addEvents.bind(this);
        //this.removeEvents = this.removeEvents.bind(this);

        this.navRef = React.createRef();
    }

    componentDidMount() {
        //this.addEvents();
        if (this.props.tree) {
            //console.debug("componentDidMount - tree", this.props.tree);
            this.props.tree.resetNavigation();
        }
    }

    componentWillUnmount() {
    }



    componentDidUpdate(prevProps, prevState) {
        if (this.props.tree.MobileViewHeight !== this.currentHeight) {
            this.currentHeight = this.props.tree.MobileViewHeight;
        }


    }

    //addEvents() {
    //	this.props.addEvents();
    //}

    //removeEvents(caller) {
    //	this.props.removeEvents(caller);
    //}


    render() {
        // Handle url-generation from Navigation to app

        if (!this.props.tree) {
            //console.debug("no-tree", this.props);
            return null;
        }
        //const matchedComponent = this.props.match.params["component"];
        return (
            <nav className="slideable-menu" style={{ height: this.props.tree.MobileViewHeight }} ref={this.navRef}>
                <MobileNavigationLevel
                    navigationStore={this.navigationStore}
                    tree={this.props.tree}
                    addNodes={this.props.addNodes}
                    node={this.props.tree}
                    viewHeight={this.props.tree.MobileViewHeight}
                    level={0}

                />
            </nav>
        );
    }
}



@observer
class MobileNavigationLevel extends React.Component {
    inView = "";
    constructor(props) {

        super(props);
        // own component height
        this.navigationStore = this.props.navigationStore;
        this.navigateToSiteUrl = this.navigateToSiteUrl.bind(this);
        this.navigateToChild = this.navigateToChild.bind(this);
        this.navigateToId = this.navigateToId.bind(this);
        this.onResize = this.onResize.bind(this);
        this.update = this.update.bind(this);
        this.changeSite = this.changeSite.bind(this);
    }

    navigateToSiteUrl(event, url, name) {
        event.preventDefault();
        //this.navigationStore.navigateToSiteUrl(this.props.tree, url, name);
        this.navigationStore.updateLocationWithoutFacets(url);
        //this.navigationStore.closeToolbar();
    }

    navigateToChild(event, child) {
        event.preventDefault();
        this.props.tree.navigateToChild(child);
    }

    navigateToId(event, id) {
        event.preventDefault();
        this.props.tree.navigateToId(id);
    }

    componentDidMount() {
        this.update();
    }

    componentDidUpdate(prevProps, prevState) {
        this.update();
    }

    update() {

        const { clientHeight } = this.element;
        const node = this.props.node;


        // Figure out if this component is the active one
        const tree = this.props.tree;
        
        //const m = matchPath(tree.CurrentPath, { path: node.Path });

        let isExact = tree.CurrentPath === ("/" + node.NodePath);

        if (tree.CurrentPath === "" && node.NodePath === tree.NodePath) {
            isExact = true;
        }

        // If its the active one, push the viewHeight to store
        if (isExact) {
            //console.debug("CLIENTHEIGHT:", clientHeight);
            node.setMobileContentHeight(clientHeight);
            setTimeout(() => {
                tree.updateViewHeight(node.MobileContentHeight);
            },
                50);

        }


    }

    onResize(w, h) {
        this.update();
    }

    changeSite(e, url) {
        e.preventDefault();
        window.location = url;
    }

    getUrl(page, languageMarket, countryCode) {
        if (page.ExternalUrl && page.ExternalUrl.length > 0) {
            return page.ExternalUrl;
        }

        return (typeof page.FullUrl !== 'undefined' ? page.FullUrl() : page.Url) + "?switchstore=" + languageMarket + "&country=" + countryCode;
    }

    renderCase(childNode, hasChildren) {
        const linkClass = classnames(
            childNode.ImageUrl ? "has-image" : "",
        );

        if (childNode.Alias === "icom_MobileMarketNavigationCountry") {

            if (childNode.LanguageCode && childNode.LanguageCode.indexOf(",") > -1) {
                return (<div className="multi-lang">
                    {childNode.ImageUrl && <img src={childNode.ImageUrl} style={{ height: "16px" }}  alt={""}/>}{childNode.Name}
                    {childNode.d.map(
                        page => {
                            if (page == null) {
                                return null;
                            }

                            return (<a
                                key={page.HrefLang}
                                href={page.FullUrl()
                                }
                                onClick={(e) =>
                                    this.changeSite(
                                        e,
                                        this.getUrl(page,languageMarket,country.CountryCode))
                                }
                            >{page.HrefLang
                                .substr(0, 2)
                                .toUpperCase()}</a>
                            );
                        })}
                </div>);
            } else {
                return (
                    <a href=""
                        onClick={(e) => this.changeSite(e, 
                            this.getUrl(childNode,childNode.LanguageCode + "-" + childNode.MarketCode,childNode.CountryCode))}
                            //childNode.Url + "?switchstore=" + childNode.LanguageCode + "-" + childNode.MarketCode + "&country=" + childNode.CountryCode)}
                        className={linkClass}
                    >{childNode.ImageUrl && <img src={childNode.ImageUrl} style={{ height: "16px" }} />}{childNode
                        .Name}</a>
                );
            }
        }
        if (hasChildren) {
            return (
                <a href={childNode.Url} className={linkClass}
                   // onClick={event => this.navigateToChild(event, childNode)}
                   onClick={event => this.navigateToSiteUrl(event, childNode.Url, name)}
                >{childNode.ImageUrl && <img src={childNode.ImageUrl} style={{ height: "16px" }} />}{childNode.Name}</a>
            );
        }

        if (childNode.Component) {
            return (
                <a href=""
                    onClick={event => this.navigateToChild(event, childNode)} className={linkClass}
                >{childNode.ImageUrl && <img src={childNode.ImageUrl} style={{ height: "16px" }} />}{childNode
                    .Name}</a>
            );

        }
        else if (childNode.Alias === "icom_menuHeading") {
            return null; //(<span>{childNode.Name}</span>);
        }

        else if (childNode.Url.indexOf("://") > -1) {
            return (
                <a href={childNode.Url} className={linkClass}
                >{childNode.ImageUrl && <img src={childNode.ImageUrl} style={{ height: "16px" }} />}{childNode.Name}</a>
            );
        }
        else if (childNode.Url[0] === "/") {
            return (
                <a href={childNode.Url}
                    onClick={event => this.navigateToSiteUrl(event, childNode.Url, name)} className={linkClass}
                >{childNode.ImageUrl && <img src={childNode.ImageUrl} style={{ height: "16px" }} />}{childNode.Name}</a>
            );
        }
        else {
            if (childNode.Url === "" && hasChildren) {
                return (<a href=""
                    onClick={event => this.navigateToChild(event, childNode)} className={linkClass}
                >{childNode.ImageUrl && <img src={childNode.ImageUrl} style={{ height: "16px" }} />}{childNode.Name}</a>
                );
            }
            else {
                return (
                    <Link
                        to={childNode.Url} className={linkClass}>
                        <span>{childNode.ImageUrl && <img src={childNode.ImageUrl} style={{ height: "16px" }} />}{childNode.Name}</span>
                    </Link>);
            }
        }
    }

    format = function(fmt, ...args) {
        if (!fmt.match(/^(?:(?:(?:[^{}]|(?:\{\{)|(?:\}\}))+)|(?:\{[0-9]+\}))+$/)) {
            throw new Error('invalid format string.');
        }
        return fmt.replace(/((?:[^{}]|(?:\{\{)|(?:\}\}))+)|(?:\{([0-9]+)\})/g, (m, str, index) => {
            if (str) {
                return str.replace(/(?:{{)|(?:}})/g, m => m[0]);
            } else {
                if (index >= args.length) {
                    throw new Error('argument index is out of range in format');
                }
                return args[index];
            }
        });
    }

    render() {
        const tree = this.props.tree;
        const level = this.props.level;
        const node = this.props.node;

        if (node.isDivider) {
            return;
        }

        const mobileViewHeight = this.props.viewHeight;

        const currentLevel = level + 1;
        const isExpanded = node.Expanded;
        const isSubLevel = level > 0;
        const isTopLevel = level === 0;

        // is the component off-View, or in-View?
        let offView_On = false;
        let inView_On = false;

        const match = tree.CurrentPath.indexOf("/" + node.NodePath) > -1;
        if (match) {
            const isExact = tree.CurrentPath === ("/" + node.NodePath);
            offView_On = !isExact;
            inView_On = isExact;
        }

        if (tree.CurrentPath === "" && node.NodePath === tree.NodePath) {
            inView_On = true;
        }

        const menuStyle = {
            //minHeight: 500,//(window.innerHeight - 150),
            height:
                node.MobileContentHeight === 0 || (isSubLevel && !isExpanded) || inView_On
                    ? "auto"
                    : mobileViewHeight
        };

        const menuClassName = classnames(
            isTopLevel ? "menu" : null,
            isExpanded ? "expanded-submenu" : "slideable-submenu",
            
            //!isSubMenu ? "menu" : "slideable-submenu " + (node.Component && node.Component === "UserEdit" ? "no-animation" : ""),
            offView_On ? "off-view" : "",
            inView_On ? "in-view" : "",
        );

        const marketNodeId = this.navigationStore.marketSettings.MarketNavigationTree.Id;

        //todo: render breadcrumbs
        const returnNode = (node.Parent || tree).Id === marketNodeId ? tree : node.Parent || tree;

        const backButton = isSubLevel && !isExpanded 
            ? (
                <li
                    key={"back"}
                    className="back-btn"
                    onClick={event => {
                        this.navigateToChild(event, returnNode);
                    }
                    }>
                    <span>
                        <a href=""><FontAwesomeIcon icon={["fas", "angle-left"]} />{node.Alias === "icom_MobileMarketNavigation" ? this.navigationStore.dictionary.ChooseCountry : node.Name}</a>
                    </span>
                </li>
            )
            :null;

        const resizeDetector = <ReactResizeDetector handleWidth handleHeight onResize={this.onResize} />;
        const pathname = this.navigationStore.mainRouter.location.pathname;

        

        return (
            <ul
                className={menuClassName}
                ref={element => (this.element = element)}
                style={menuStyle}>
                {backButton}
                {resizeDetector}

                <React.Fragment>
                    {
                        node.ChildrenView(this.props.addNodes).filter(x => x.Visible && x.Alias !== "icom_category").flatMap(childNode => {
                            
                            const hasLinkBackgroundProperty = childNode.PropertyByKey("linkBackground")
                            const hasLinkBackgroundColor = hasLinkBackgroundProperty != null 
                                ? hasLinkBackgroundProperty.toLowerCase()
                                : null;
                            
                            const expanded = childNode.Expanded;
                            const hasChildren = childNode.ChildrenView(this.props.addNodes).filter(x => x.Url !== "" && x.Visible).length > 0 || childNode.Component;
                            const hasUrl = childNode.Url !== undefined && childNode.Url !== "";
                            const liClassNames = classnames(
                                hasLinkBackgroundColor,    
                                hasUrl ? "has-url" : "",
                                hasChildren ? "has-children" : "",
                                expanded ? "is-expanded" : "",
                                (childNode.Url && (pathname.indexOf(childNode.Url) > -1)) ? "active" : ""
                            );

                            if (childNode.IsProtected) {
                                if (!childNode.HasAccess) {
                                    return null;
                                }
                            }

                            if (childNode.IsDivider) {
                                return null;
                            }
                            
                            if(childNode.Alias === "icom_menuGroup") {
                                return childNode.ChildrenView().filter(x => x.Visible && x.Alias !== "icom_category").flatMap(menuGroupChildNode => {
                                    return (<li key={menuGroupChildNode.Id} className={liClassNames}>
                                        <span>
                                            {this.renderCase(menuGroupChildNode, hasChildren)}
                                        </span>
                                    </li>);
                                });
                               
                            }
                            
                            
                            return (
                                <li key={childNode.Id} className={liClassNames}>
                                    {childNode.Visible &&
                                        <span>
                                            {this.renderCase(childNode, hasChildren)}
                                            {(!expanded && hasChildren) && (
                                                <span 
                                                    className="sub-menu-toggle"
                                                    onClick={event => this.navigateToChild(event, childNode)}
                                                >
                                                    <FontAwesomeIcon icon={["fas", "angle-right"]} />
                                                </span>
                                            )}
                                        </span>
                                    }
                                    {
                                        (hasChildren || childNode.Component) && (
                                            <MobileNavigationLevel
                                                {...this.props}
                                                node={childNode}
                                                level={currentLevel}
                                                viewHeight={null}

                                            />)
                                    }
                                </li>
                            );
                        })
                    }


                    {/*
                    {currentMarket &&
                        <li key={"market-selector"} className={"has-children"}>
                            <span>
                                <a href="" onClick={event => this.navigateToChild(event, currentMarket)}>
                                    <div className="market-selector">
                                        <img src={"/dist/img/flags/" + currentMarket.MarketCode + ".svg"} alt={currentMarket.MarketCode} /> {currentMarket.Name}
                                    </div>
                                </a>
                            </span>
                            <MobileNavigationLevel
                                {...this.props}
                                node={currentMarket}
                                level={currentLevel}
                                viewHeight={null}
                            />
                        </li>*/}

                </React.Fragment>
                {/*{this.navigationStore.dictionary.ViewAll && this.navigationStore.dictionary.ViewAllLevel1 && level === 1 && (node.Alias === "icom_category" || node.Alias === "icom_filter") && <li className={"has-url view-all"}><span><a href={node.Url}*/}
                {/*                                                                                                                                                                           onClick={event => this.navigateToSiteUrl(event, node.Url, name)}>{this.format(this.navigationStore.dictionary.ViewAllLevel1, node.Name.toLowerCase())}</a></span></li>}*/}
                {/*{this.navigationStore.dictionary.ViewAll && level === 2 && (node.Alias === "icom_category" || node.Alias === "icom_filter") && <li className={"has-url view-all"}><span><a href={node.Url}*/}
                {/*                                                        onClick={event => this.navigateToSiteUrl(event, node.Url, name)}>{this.navigationStore.dictionary.ViewAll}</a></span></li>}*/}
            </ul>
        );
    }
}



//export default withRouter(MobileNavigation)